import { GoogleLogin, GoogleOAuthProvider } from "@react-oauth/google";
import { useNavigate } from "react-router-dom";
import { generateFullFingerprintPayload } from "../Tools/fingerprint";
import { hasSecurityFingerprintConsent } from "../Tools/fingerprintConsent";

function RegisterGoogle() {
  const navigate = useNavigate();
  return (
    <div>
      <h2>Register with Google</h2>

      <GoogleOAuthProvider clientId="801390879975-n7n4ji4c9nfhr1q8bfm9reste21tn4ci.apps.googleusercontent.com">
      <GoogleLogin
        onSuccess={async (credentialResponse) => {
          const token = credentialResponse.credential;
          const fingerprint = hasSecurityFingerprintConsent()
            ? await generateFullFingerprintPayload()
            : null;

          fetch("/api/auth/google", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            credentials: "include",
            body: JSON.stringify({ token, fingerprint, deviceRecognitionConsent: hasSecurityFingerprintConsent() }),
          })
            .then((res) => res.json())
            .then((data) => {
              if (data.ok) {
                window.dispatchEvent(new Event("bubly:session-changed"));
                navigate("/profile");
              }
            });
        }}
        onError={() => {
            console.error("Google Login error.");
        }}
      />
      </GoogleOAuthProvider>
    </div>
  );
}

export default RegisterGoogle;
